import { useState } from 'react'
import ImageUploader from './ImageUploader'
import './AlbumImages.css'

const IMAGE_SLOTS = [
  { id: 'front', label: 'Front Cover', required: true },
  { id: 'insideFront', label: 'Inside Front' },
  { id: 'insideBack', label: 'Inside Back' },
  { id: 'back', label: 'Back Cover' },
]

const PLACEHOLDER_ART = 'data:image/svg+xml,' + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <rect fill="#1E1A22" width="100" height="100"/>
    <circle cx="50" cy="50" r="30" fill="none" stroke="#6E2EBF" stroke-width="2"/>
    <circle cx="50" cy="50" r="10" fill="#6E2EBF"/>
  </svg>
`)

export default function AlbumImages({ images = {}, onChange }) {
  const [expandedSlot, setExpandedSlot] = useState(null)

  const handleImageChange = (slotId, url) => {
    onChange({
      ...images,
      [slotId]: url || null
    })
  }

  const handleRemoveImage = (slotId) => {
    const updated = { ...images }
    delete updated[slotId]
    onChange(updated)
  }

  return (
    <div className="album-images">
      <label className="album-images-label">Album Artwork</label>
      <div className="album-images-grid">
        {IMAGE_SLOTS.map(slot => {
          const imageUrl = images[slot.id]
          const isExpanded = expandedSlot === slot.id

          return (
            <div key={slot.id} className={`album-image-slot ${imageUrl ? 'has-image' : ''}`}>
              <div className="slot-header">
                <span className="slot-label">
                  {slot.label}
                  {slot.required && <span className="required">*</span>}
                </span>
                {imageUrl && (
                  <button
                    type="button"
                    className="slot-remove"
                    onClick={() => handleRemoveImage(slot.id)}
                    title="Remove image"
                  >
                    ×
                  </button>
                )}
              </div>

              {imageUrl ? (
                <div className="slot-preview">
                  <img
                    src={imageUrl}
                    alt={slot.label}
                    onError={(e) => { e.target.src = PLACEHOLDER_ART }}
                    onClick={() => setExpandedSlot(isExpanded ? null : slot.id)}
                  />
                  <button
                    type="button"
                    className="slot-change"
                    onClick={() => setExpandedSlot(isExpanded ? null : slot.id)}
                  >
                    {isExpanded ? 'Cancel' : 'Change'}
                  </button>
                </div>
              ) : (
                <div className="slot-empty">
                  <ImageUploader
                    value=""
                    onChange={(url) => handleImageChange(slot.id, url)}
                    folder="albums"
                    compact
                  />
                </div>
              )}

              {isExpanded && imageUrl && (
                <div className="slot-uploader">
                  <ImageUploader
                    value=""
                    onChange={(url) => {
                      handleImageChange(slot.id, url)
                      setExpandedSlot(null)
                    }}
                    folder="albums"
                    compact
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

// Helper to get the primary cover image (for display elsewhere)
export function getPrimaryCover(images, legacyCoverArtUrl) {
  if (images?.front) return images.front
  if (legacyCoverArtUrl) return legacyCoverArtUrl
  return null
}

// Export the slots for use in other components
export { IMAGE_SLOTS }
